module.exports = "https://p.cds.unp.clasificados.pe/bg-oportunidades.94fcbec0b206d1fc59e5b7cffc3eae22.jpg";